import * as Sentry from "@sentry/react";
import { getAppConfig } from "../config";

export function init() {
    const config = getAppConfig();

    const remoteEnv = ["development", "staging", "production"];

    if (remoteEnv.includes(config.appEnvName)) {
        Sentry.init({
            dsn: config.sentry.dnsUrl
        });
    }
}

export function setUser(userId: string) {
    Sentry.setUser({ id: userId });
}

export const ErrorBoundary = Sentry.ErrorBoundary;
